import styled from '@emotion/styled';
import { EmotionTheme } from 'theme/emotionTheme';
import { BannerBar } from './components/BannerBar';

import { HeroSection } from './components/HeroSection';
import { WhatYouGet } from './components/WhatYouGet';
import { InNetwork } from './components/InNetwork';
import { HowItWorks } from './components/HowItWorks';
import { SupportedConditions } from './components/SupportedConditions';
import { FeaturedBar } from './components/FeaturedBar';
import { Reviews } from './components/Reviews';
import { Footer } from './components/Footer';

const GradientBox = styled('div')<{ theme?: EmotionTheme }>`
  background-image: linear-gradient(
    0deg,
    #ebf5ff 0%,
    #ffffff 50%,
    #ebf5ff 100%
  );
  min-height: 100vh;
`;

export const NewLandingPage = ({ onStartOnboarding, startOnboardingError }) => {
  return (
    <GradientBox>
      <BannerBar />
      <HeroSection
        onStartOnboarding={onStartOnboarding}
        startOnboardingError={startOnboardingError}
      />
      <WhatYouGet onStartOnboarding={onStartOnboarding} />
      <InNetwork onStartOnboarding={onStartOnboarding} />
      <HowItWorks onStartOnboarding={onStartOnboarding} />
      <SupportedConditions />
      <FeaturedBar />
      <Reviews />
      <Footer onStartOnboarding={onStartOnboarding} />
    </GradientBox>
  );
};
